import { render, staticRenderFns } from "./SendMessageFilePreviewModal.vue?vue&type=template&id=560825de&scoped=true&lang=pug"
import script from "./SendMessageFilePreviewModal.vue?vue&type=script&lang=ts"
export * from "./SendMessageFilePreviewModal.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageFilePreviewModal.vue?vue&type=style&index=0&id=560825de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560825de",
  null
  
)

export default component.exports